
'use strict';

module.exports = function (angular, app) {
    app.service('settingsService', [
        '$http',
        '$rootScope',
        '$q',
        'toastr',
        'UserEnvironment',
        function ($http, $rootScope, $q, toastr, UserEnvironment) {
            function error(response) {
                var message = "No connection to server";

                if (response.status === 403 || response.status === 401) {
                    message = "You no longer have permission to complete this action";
                } else if (response.status > 0) {
                    message = (response.status + " " + response.data);
                }

                // toastr.error(message);
            }

            function updateProfile(name, lastName) {

                let user = UserEnvironment.getUser();

                var profile = {name: String(name || ''), lastName: String(lastName || '')};

                return $http.post(`/users/${user._id}`, profile).then(() => {
                    toastr.success("Your name has been updated");

                    UserEnvironment.updateUserProfile(profile);
                    return profile;
                }, error);
            }

            function updateEmail(email) {
                let user = UserEnvironment.getUser();
                return $http.post(`/users/${user._id}`, {email: String(email || '')}).then(function ({data}) {
                    toastr.success("Your email was changed to " + data.email);

                    UserEnvironment.logOut();
                }, error);
            }

            function isAdminOf(organization) {
                return organization && (organization.role === "admin" || organization.role === "owner") || false;
            }

            function canViewKeys(organization) {
                return isAdminOf(organization) && organization.streams.length !== 0;
            }

            function canSetIntegrations(organization) {
                return isAdminOf(organization);
            }

            return {
                updateProfile: updateProfile,
                updateEmail: updateEmail,
                isAdminOf: isAdminOf,
                canViewKeys: canViewKeys,
                canSetIntegrations: canSetIntegrations
            };
        }
    ]);
};
